(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ncform/ncform-common"));
	else if(typeof define === 'function' && define.amd)
		define("vueNcform", ["ncformCommon"], factory);
	else if(typeof exports === 'object')
		exports["vueNcform"] = factory(require("@ncform/ncform-common"));
	else
		root["vueNcform"] = factory(root["ncformCommon"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 